import { useState, useMemo } from "react";

const allCities = [
  { name: "Ashland", route: "/ashland", tagline: "Boyd County expedited passport services", highlights: ["Tri-State area coverage", "Serving Huntington, WV and Ironton, OH"], badge: null, status: "live" },
  { name: "Bardstown", route: "/bardstown", tagline: "Nelson County expedited passport processing", highlights: ["Bourbon Trail area coverage", "Serving Springfield, Taylorsville"], badge: null, status: "live" },
  { name: "Berea", route: "/berea", tagline: "Madison County passport courier service", highlights: ["Berea area coverage", "Serving Richmond, Mount Vernon"], badge: null, status: "live" },
  { name: "Bowling Green", route: "/bowling-green", tagline: "Warren County expedited passport hub", highlights: ["South Central Kentucky coverage", "Serving Glasgow, Franklin"], badge: null, status: "live" },
  { name: "Covington", route: "/covington", tagline: "Northern Kentucky expedited passport services", highlights: ["Cincinnati metro area", "Serving Newport, Florence, Erlanger"], badge: null, status: "live" },
  { name: "Danville", route: "/danville", tagline: "Boyle County expedited passport processing", highlights: ["Danville area coverage", "Serving Harrodsburg, Stanford, Lancaster"], badge: null, status: "live" },
  { name: "Elizabethtown", route: "/elizabethtown", tagline: "Hardin County expedited passport hub", highlights: ["Elizabethtown area", "Serving Radcliff, Fort Knox, Shepherdsville"], badge: null, status: "live" },
  { name: "Erlanger", route: "/erlanger", tagline: "Kenton County expedited passport services", highlights: ["Northern Kentucky coverage", "Serving Florence, Independence"], badge: null, status: "live" },
  { name: "Florence", route: "/florence", tagline: "Boone County expedited passport processing", highlights: ["Florence area coverage", "Serving Union, Hebron, Burlington"], badge: null, status: "live" },
  { name: "Fort Mitchell", route: "/fort-mitchell", tagline: "Kenton County passport courier service", highlights: ["Fort Mitchell area", "Serving Covington, Edgewood, Crestview Hills"], badge: null, status: "live" },
  { name: "Fort Thomas", route: "/fort-thomas", tagline: "Campbell County expedited passport services", highlights: ["Fort Thomas area coverage", "Serving Newport, Bellevue"], badge: null, status: "live" },
  { name: "Frankfort", route: "/frankfort", tagline: "Franklin County expedited passport hub", highlights: ["State capital area", "Serving Lawrenceburg, Versailles, Georgetown"], badge: null, status: "live" },
  { name: "Georgetown", route: "/georgetown", tagline: "Scott County expedited passport processing", highlights: ["Georgetown area coverage", "Serving Lexington, Frankfort, Paris"], badge: null, status: "live" },
  { name: "Glasgow", route: "/glasgow", tagline: "Barren County passport courier service", highlights: ["Glasgow area coverage", "Serving Cave City, Edmonton, Bowling Green"], badge: null, status: "live" },
  { name: "Henderson", route: "/henderson", tagline: "Henderson County expedited passports", highlights: ["Henderson area", "Serving Owensboro, Evansville IN"], badge: null, status: "live" },
  { name: "Hopkinsville", route: "/hopkinsville", tagline: "Christian County expedited passport services", highlights: ["Hopkinsville area coverage", "Serving Fort Campbell, Oak Grove"], badge: null, status: "live" },
  { name: "Independence", route: "/independence", tagline: "Kenton County expedited passport processing", highlights: ["Independence area", "Serving Erlanger, Taylor Mill"], badge: null, status: "live" },
  { name: "Jeffersontown", route: "/jeffersontown", tagline: "Jefferson County expedited passport services", highlights: ["Jeffersontown area", "Serving Louisville, St. Matthews"], badge: null, status: "live" },
  { name: "Lexington", route: "/lexington", tagline: "Fayette County's trusted expedited passport hub", highlights: ["24-hour emergency service", "Serving Georgetown, Richmond, Nicholasville"], badge: "Most Popular", status: "live" },
  { name: "Louisville", route: "/louisville", tagline: "Jefferson County emergency passport services", highlights: ["24-hour processing available", "Kentucky's largest metro area"], badge: "Most Popular", status: "live" },
  { name: "Middlesborough", route: "/middlesborough", tagline: "Bell County expedited passport services", highlights: ["Middlesborough area", "Serving Pineville, Harlan"], badge: null, status: "live" },
  { name: "Morehead", route: "/morehead", tagline: "Rowan County expedited passport processing", highlights: ["Morehead area coverage", "Serving Mount Sterling, West Liberty, Ashland"], badge: null, status: "live" },
  { name: "Mount Washington", route: "/mount-washington", tagline: "Bullitt County passport courier service", highlights: ["Mount Washington area", "Serving Louisville, Shepherdsville"], badge: null, status: "live" },
  { name: "Murray", route: "/murray", tagline: "Calloway County expedited passports", highlights: ["Murray area coverage", "Serving Paducah, Mayfield"], badge: null, status: "live" },
  { name: "Newport", route: "/newport", tagline: "Campbell County expedited passport services", highlights: ["Newport area coverage", "Serving Covington, Bellevue"], badge: null, status: "live" },
  { name: "Nicholasville", route: "/nicholasville", tagline: "Jessamine County expedited passport processing", highlights: ["Nicholasville area", "Serving Lexington, Wilmore"], badge: null, status: "live" },
  { name: "Owensboro", route: "/owensboro", tagline: "Daviess County expedited passport hub", highlights: ["Owensboro area coverage", "Serving Henderson, Madisonville"], badge: null, status: "live" },
  { name: "Paducah", route: "/paducah", tagline: "McCracken County expedited passport services", highlights: ["Western Kentucky coverage", "Serving Murray, Mayfield"], badge: null, status: "live" },
  { name: "Radcliff", route: "/radcliff", tagline: "Hardin County expedited passport processing", highlights: ["Radcliff area", "Serving Elizabethtown, Fort Knox"], badge: null, status: "live" },
  { name: "Richmond", route: "/richmond", tagline: "Madison County passport courier service", highlights: ["Richmond area coverage", "Serving Berea, Lexington, Nicholasville"], badge: null, status: "live" },
  { name: "Shelbyville", route: "/shelbyville", tagline: "Shelby County expedited passports", highlights: ["Shelbyville area", "Serving Louisville, Simpsonville"], badge: null, status: "live" },
  { name: "Shively", route: "/shively", tagline: "Jefferson County expedited passport services", highlights: ["Shively area coverage", "Serving Louisville, Valley Station"], badge: null, status: "live" },
  { name: "Somerset", route: "/somerset", tagline: "Pulaski County expedited passport processing", highlights: ["Lake Cumberland area", "Serving London, Corbin, Williamsburg"], badge: null, status: "live" },
  { name: "Versailles", route: "/versailles", tagline: "Woodford County passport courier service", highlights: ["Versailles area coverage", "Serving Lexington, Frankfort"], badge: null, status: "live" },
  { name: "Winchester", route: "/winchester", tagline: "Clark County expedited passports", highlights: ["Winchester area", "Serving Lexington, Paris"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function KentuckyCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Kentucky Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Kentucky Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Kentucky</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Kentucky locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}